import {
  LinearProgress,
  Paper,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";

import { useFacets, useLaddersContent } from "../../hooks/useCMSData";
import { Iconify } from "../../components/iconify/iconify";
import { useMyProgress } from "@/hooks/useMyProgress";
import { getResolvedFacetTotals } from "../../utils/facet-util";

const FacetBox = styled("div")(({ backgroundColor }) => ({
  padding: 10,
  border: "1px solid #ccc",
  borderRadius: 5,
  display: "flex",
  flexDirection: "column",
  gap: 10,
  width: 500,
  backgroundColor: backgroundColor || "#e4f8eb",
}));

const FacetInfo = ({ facet, facetsCMS, scores }) => {
  const facetCMS = facetsCMS.find((f) => f.facetCode === facet);
  if (!facetCMS)
    return (
      <FacetBox backgroundColor={facetsCMS?.secondaryColor}>
        Unknown Facet {facet}
      </FacetBox>
    );
  return (
    <FacetBox backgroundColor={facetsCMS?.secondaryColor}>
      <Typography variant="heading">
        {facetCMS.icon && (
          <img
            style={{ width: 48, height: 48 }}
            src={facetCMS.icon}
            alt={facetCMS.facet}
          />
        )}
        <Iconify icon={facetCMS.iconifyIcon} />
        {facetCMS.type} / {facetCMS.facet} / {facetCMS.variable}
        <span style={{ float: "right" }}>
          {scores.total} / {scores.possible}
        </span>
      </Typography>
      <div style={{ color: facetCMS.color || "#078dee" }}>
        <LinearProgress
          variant="determinate"
          color="inherit"
          value={(scores.total / scores.possible) * 100}
        />
      </div>
      <Typography>{facetCMS.description}</Typography>
    </FacetBox>
  );
};

export const FacetsDebug = () => {
  const { ladderContent } = useLaddersContent();
  const { facets: facetsCMS, loading } = useFacets();

  const { progress, facets } = useMyProgress();

  if (loading) return <div>Loading...</div>;
  if (!facets) return <div>No facets found</div>;

  // Calculate total scores for each facet type across ladders
  const facetTotals = getResolvedFacetTotals(progress);

  // facets.reduce((totals, ladder) => {
  //   ladder.facets.forEach(({ facet, score }) => {
  //     if (!totals[facet]) {
  //       totals[facet] = { total: 0, possible: 0 };
  //     }
  //     totals[facet].total += score[0];
  //     totals[facet].possible += score[1];
  //   });
  //   return totals;
  // }, {});

  const getLadderTitle = (ladderId) => {
    const ladder = ladderContent?.find((l) => String(l.id) == String(ladderId));
    return ladder?.name;
  };

  return (
    <FacetsDebugContainer>
      <h1>Current climber values</h1>
      {/* <pre>{JSON.stringify(currentUser.riasec, null, 2)}</pre> */}

      <h1>Total Facet Scores</h1>
      <FacetList>
        {Object.entries(facetTotals).map(([facet, scores], i) => (
          <FacetInfo
            key={i}
            facet={facet}
            facetsCMS={facetsCMS}
            scores={scores}
          />
        ))}
      </FacetList>

      <h1>Values by ladder</h1>
      <TableContainer component={Paper}>
        {facets.map((facetRecord, i) => (
          <div key={i}>
            <h2 key={i}>
              (Ladder #{facetRecord.ladderId}){" "}
              {getLadderTitle(facetRecord.ladderId)}
            </h2>
            <Table key={`table-${i}`} sx={{ maxWidth: 800 }}>
              <TableBody>
                <TableRow>
                  <TableCell>Ladder ID</TableCell>
                  <TableCell>Facet</TableCell>
                  <TableCell>Score</TableCell>
                </TableRow>
                {facetRecord.facets.map(({ facet, score }, i) => (
                  <TableRow key={i}>
                    <TableCell key={facet.ladderId}>
                      {facetRecord.ladderId}
                    </TableCell>
                    <TableCell>{facet}</TableCell>
                    <TableCell>
                      {score[0]} / {score[1]}
                      <LinearProgress
                        variant="determinate"
                        value={(score[0] / score[1]) * 100}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        ))}
      </TableContainer>
    </FacetsDebugContainer>
  );
};

const FacetList = styled("div")`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 20px;
  padding: 30px;
`;

const FacetsDebugContainer = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 30px;
`;
